module.exports = __webpack_public_path__ + "img/5-2_03.7b58c8e0.jpg";